var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3581 12.0002L10.9481 13.4102C10.1681 14.1902 10.1681 15.4602 10.9481 16.2402C11.7281 17.0202 12.9981 17.0202 13.7781 16.2402L15.9981 14.0202C17.5581 12.4602 17.5581 9.93019 15.9981 8.36019C14.4381 6.80019 11.9081 6.80019 10.3381 8.36019L7.91809 10.7802C6.57809 12.1202 6.57809 14.2902 7.91809 15.6302",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1582 22.2002H15.1582C20.1582 22.2002 22.1582 20.2002 22.1582 15.2002V9.2002C22.1582 4.2002 20.1582 2.2002 15.1582 2.2002H9.1582C4.1582 2.2002 2.1582 4.2002 2.1582 9.2002V15.2002C2.1582 20.2002 4.1582 22.2002 9.1582 22.2002Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.0fdc408b.svg";
export { ForwardRef as ReactComponent };